import ZiniPixelsPrototype from "./ZiniPixelsPrototype";

export default ZiniPixelsPrototype;
